//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    height: {
      type: String,
      default: '252px'
    },
    dateList: {
      type: Array,
      default: []
    },
    top: {
      type: String,
      default: '33px'
    },
    paddingTop: {
      type: String,
      default: '0'
    },
    minSum: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      moveState: false,
      overflow: 'hidden'
    };
  },
  watch: {
    moveState: function moveState(value) {
      if (value) {
        this.overflow = 'auto';
      } else {
        this.overflow = 'hidden';
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.Inter);
  },
  mounted: function mounted() {
    var _this = this;

    this.Inter = setInterval(function () {
      setTimeout(function () {
        if (_this.dateList.length > _this.minSum) {
          _this.dateList.push(_this.dateList[0]); // 将数组的第一个元素添加到数组的


          _this.dateList.shift(); //删除数组的第一个元素

        }
      }, 500);
    }, 1500);
  },
  methods: {
    toggleState: function toggleState() {
      var _this2 = this;

      this.moveState = !this.moveState;

      if (this.moveState) {
        clearInterval(this.Inter);
      } else {
        var data = JSON.parse(JSON.stringify(this.dateList));
        this.dateList = [];
        setTimeout(function () {
          _this2.dateList = data;
          _this2.Inter = setInterval(function () {
            setTimeout(function () {
              if (_this2.dateList.length > _this2.minSum) {
                _this2.dateList.push(_this2.dateList[0]); // 将数组的第一个元素添加到数组的


                _this2.dateList.shift(); //删除数组的第一个元素

              }
            }, 500);
          }, 1000);
        }, 10);
      }
    }
  }
};